import Model from '@/lib/data/Model';

class PolicyFollowUp extends Model {
    static idProperty = 'id';

    fields = ['id', 'policy_id', 'recommendation', 'complete_date', 'fu_status'];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'saveOrUpdatePolicyFollowUp',
            url: '/policy/followup/saveorupdate',
            associated: true,
        },
        {
            name: 'removePolicyFollowUp',
            url: '/policy/followup/remove',
            params: ['id'],
        },
    ];
}

export default PolicyFollowUp;
